import './LinksBarButton.css'
import * as React from "react";
import {Link, withRouter} from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';

class LinksBarButton extends React.Component {

  createLink() {
    if (this.props.queryParam) {
      const location = this.props.location;
      const search = new URLSearchParams(location.search);

      if (this.props.value === null || this.props.value === undefined || this.isActive()) {
        search.delete(this.props.queryParam);
      } else {
        search.set(this.props.queryParam, this.props.value);
      }

      search.delete("page");

      return location.pathname + "?" + search.toString();
    }
  }

  isActive() {
    if (this.props.selectedValue === this.props.value) {
      return true;
    } else if (this.props.queryParam) {
      return new URLSearchParams(this.props.location.search).get(this.props.queryParam) === this.props.value;
    } else {
      return false;
    }
  }

  isNotDefaultOption() {
    return this.props.value !== null && this.props.value !== undefined;
  }

  onClick() {
    if (this.props.callback) {
      this.props.callback(this.isActive() ? null : this.props.value);
    }
  }

  render() {
    if (this.props.component) {
      const Component = this.props.component;
      return <Component className={"links-bar-button " + (this.props.removePadding ? "removed-padding" : "")}>{this.props.label}</Component>
    }
    else if (this.props.queryParam) {
      return <Link className={"links-bar-button " + (this.isActive() ? "active " : "") + (this.isActive() && this.isNotDefaultOption() ? "closable " : "") + (this.props.removePadding && !this.isActive() ? "removed-padding" : "")} to={this.createLink()}>{this.props.label}{(this.isActive() && this.isNotDefaultOption()) && <span className={"links-bar-button-close"}><CloseIcon fontSize={"small"}/></span>}</Link>
    } else {
      return <div className={"links-bar-button " + (this.isActive() ? "active " : "") + (this.isActive() && this.isNotDefaultOption() ? "closable " : "") + (this.props.removePadding && !this.isActive() ? "removed-padding" : "")} onClick={this.onClick.bind(this)}>{this.props.label}{(this.isActive() && this.isNotDefaultOption()) && <span className={"links-bar-button-close"}><CloseIcon fontSize={"small"}/></span>}</div>
    }
  };
}

export default withRouter(LinksBarButton);
